import { HttpParams } from '@angular/common/http';
import { InjectionToken } from '@angular/core';
import { AbstractControl } from '@angular/forms';

/**
 * Created by Shay.Libo on 4/18/2017.
 */
declare var CKEDITOR: any;
export function trimFormValue(formControl: AbstractControl): void {
  if (formControl && formControl.value) {
    const trimmed = formControl.value.trim();
    if (trimmed.length !== formControl.value.length) {
      formControl.setValue(trimmed);
    }
  }
}

export const WEB_API_URL = new InjectionToken<string>(
  'please provide WEB_API_URL in the provider list of your module'
);

export class Utils {
  static focusedCKEditorTriggerBlurEvent() {
    if (CKEDITOR.currentInstance) {
      if (CKEDITOR.currentInstance.focusManager.hasFocus) {
        CKEDITOR.currentInstance.focusManager.blur(true);
      }
    }
  }

  static getParameterByName(name: string, defaultValue: string = null) {
    var url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) {
      if (!defaultValue) return null;
      else return defaultValue;
    }
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
  static getParameterByNames(
    names: string[],
    defaultValue: string = null
  ): string {
    const params = new HttpParams({
      fromString: window.location.search.substring(1),
    });

    //this will just return the first one found there shouldn't be 2 lang keys
    const found = names.find((n) => params.get(n));
    return found ? params.get(found) : defaultValue;
  }

  static bytesToBase64(a: any) {
    if (typeof btoa === 'function') {
      return btoa(Utils.bytesToString(a));
    }

    let b = [];
    for (let c = 0; c < a.length; c += 3)
      for (var d = (a[c] << 16) | (a[c + 1] << 8) | a[c + 2], e = 0; e < 4; e++)
        c * 8 + e * 6 <= a.length * 8
          ? b.push(
              'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.charAt(
                (d >>> (6 * (3 - e))) & 63
              )
            )
          : b.push('=');
    return b.join('');
  }

  static bytesToString(a: any) {
    let b = [];
    for (let c = 0; c < a.length; c++) b.push(String.fromCharCode(a[c]));
    return b.join('');
  }

  static stringToBytes(a: string) {
    let b = [];
    for (let c = 0; c < a.length; c++) b.push(a.charCodeAt(c) & 255);
    return b;
  }

  static convertUTF8ToBase64(utf8string: string) {
    var utf8Bytes = Utils.stringToBytes(utf8string);
    var stringBase64 = Utils.bytesToBase64(utf8Bytes);
    return stringBase64;
  }
}

export class ArrayUtils {
  static getLastElement(arr: any[]): any {
    return arr[arr.length - 1];
  }
}

export class HtmlUtils {
  static getFirstTagParent(el: HTMLElement, tag: string) {
    tag = tag.toUpperCase();
    while (el && el.nodeName !== tag) {
      el = el.parentElement;
    }
    return el;
  }
}

export class Guid {
  static S4(): string {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }

  static D4(): string {
    return (((1 + Math.random()) * 0x10000) | 0).toString(10).substring(1);
  }

  static GenerateGuid(): string {
    return (
      this.S4() +
      this.S4() +
      '-' +
      this.S4() +
      '-' +
      this.S4() +
      '-' +
      this.S4() +
      '-' +
      this.S4() +
      this.S4() +
      this.S4()
    );
  }

  static GenerateGuidNumber(): string {
    return (
      this.S4() +
      this.S4() +
      this.S4() +
      this.S4() +
      this.S4() +
      this.S4() +
      this.S4() +
      this.S4()
    );
  }
}

export class ColorUtils {
  static hexDigits = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
  ];

  //Function to convert rgb color to hex format
  static rgb2hex(rgb: string) {
    let rgbMatch = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
    return (
      '#' +
      ColorUtils.hex(parseInt(rgbMatch[1])) +
      ColorUtils.hex(parseInt(rgbMatch[2])) +
      ColorUtils.hex(parseInt(rgbMatch[3]))
    );
  }

  static hex(x: number) {
    return isNaN(x)
      ? '00'
      : ColorUtils.hexDigits[(x - (x % 16)) / 16] +
          ColorUtils.hexDigits[x % 16];
  }
}
